import {type CSSProperties, type Ref} from "react";
import classNames from "classnames";

import {IIcon} from "../types/IIcon";
import {SvgIconWrapper} from "./SvgIconWrapper";

import {svgIconBase} from "./SvgIcon.module.css";

interface IProps extends IIcon {
    ref?: Ref<HTMLDivElement>;
}

export const SvgIcon = (props: IProps) => {
    const {
        "aria-label": ariaLabel,
        children,
        className,
        dataTestId,
        fill,
        height,
        onClick,
        ref,
        size,
        viewBox,
        width,
        wrapperColor,
        wrapperSize,
        wrapperType
    } = props;

    const hasWrapper = wrapperSize && wrapperColor;
    const iconStyle = {
        "--iconFill": fill || "var(--colors-secondary)",
        "--iconSize": size || "1",
        ...(height !== undefined && {height}),
        ...(width !== undefined && {width})
    } as CSSProperties;
    const svgIconCN = classNames(svgIconBase, className);

    const icon = (
        <svg
            aria-label={ariaLabel}
            className={!hasWrapper ? svgIconCN : svgIconBase}
            data-testid={dataTestId}
            height={height}
            onClick={!hasWrapper ? onClick : undefined}
            style={iconStyle}
            viewBox={viewBox || "0 0 10 10"}
            width={width}
        >
            {children}
        </svg>
    );
    return wrapperSize && wrapperColor ? (
        <SvgIconWrapper onClick={onClick} wrapperColor={wrapperColor} wrapperSize={wrapperSize} wrapperType={wrapperType} className={className} ref={ref}>
            {icon}
        </SvgIconWrapper>
    ) : (
        icon
    );
};
import {type CSSProperties, type Ref} from "react";
import classNames from "classnames";

import {IIcon} from "../types/IIcon";
import {SvgIconWrapper} from "./SvgIconWrapper";

import {svgIconBase} from "./SvgIcon.module.css";

interface IProps extends IIcon {
    ref?: Ref<HTMLDivElement>;
}

export const SvgIcon = (props: IProps) => {
    const {
        "aria-label": ariaLabel,
        children,
        className,
        dataTestId,
        fill,
        height,
        onClick,
        ref,
        size,
        viewBox,
        width,
        wrapperColor,
        wrapperSize,
        wrapperType
    } = props;

    const hasWrapper = wrapperSize && wrapperColor;
    const iconStyle = {
        "--iconFill": fill || "var(--colors-secondary)",
        "--iconSize": size || "1",
        ...(height !== undefined && {height}),
        ...(width !== undefined && {width})
    } as CSSProperties;
    const svgIconCN = classNames(svgIconBase, className);

    const icon = (
        <svg
            aria-label={ariaLabel}
            className={!hasWrapper ? svgIconCN : svgIconBase}
            data-testid={dataTestId}
            height={height}
            onClick={!hasWrapper ? onClick : undefined}
            style={iconStyle}
            viewBox={viewBox || "0 0 10 10"}
            width={width}
        >
            {children}
        </svg>
    );
    return wrapperSize && wrapperColor ? (
        <SvgIconWrapper onClick={onClick} wrapperColor={wrapperColor} wrapperSize={wrapperSize} wrapperType={wrapperType} className={className} ref={ref}>
            {icon}
        </SvgIconWrapper>
    ) : (
        icon
    );
};
